<template>
  <div class="ap-root">

    <!-- ═══ SIDEBAR ═══ -->
    <aside class="ap-sidebar">

      <!-- Cabeçalho -->
      <div class="ap-header">
        <div class="ap-header-icon">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="#E86A10" stroke-width="2"/>
            <path d="M10 8l6 4-6 4V8z" fill="#E86A10"/>
          </svg>
        </div>
        <div class="ap-header-text">
          <div class="ap-header-title">Auto-Play Híbrido</div>
          <div class="ap-header-sub">Tela de início personalizada</div>
        </div>
        <span class="ap-status-badge ap-badge-on">ON</span>
      </div>

      <!-- Ações -->
      <div class="ap-actions">
        <button class="ap-btn-save" @click="updateSubmit()">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none"><path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z" stroke="#fff" stroke-width="2.5" stroke-linejoin="round"/><path d="M17 21v-8H7v8M7 3v5h8" stroke="#fff" stroke-width="2.5"/></svg>
          Salvar alterações
        </button>
        <router-link :to="`/player/${vslId}/customizacao`" class="ap-btn-back">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none"><path d="M19 12H5M12 19l-7-7 7-7" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
          Voltar
        </router-link>
      </div>

      <!-- Corpo -->
      <div class="ap-body" v-if="autoPlayer && autoPlayer[0]">

        <!-- Card: Estilo do Overlay -->
        <div class="ap-section-label">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none"><rect x="3" y="3" width="18" height="18" rx="3" stroke="#E86A10" stroke-width="2"/><path d="M3 9h18M9 21V9" stroke="#E86A10" stroke-width="2"/></svg>
          Estilo do Overlay
        </div>

        <div class="ap-card">
          <div class="ap-overlay-styles">
            <div
              v-for="style in overlayStyles"
              :key="style.id"
              class="ap-overlay-style-item"
              :class="{ 'ap-overlay-style-active': Number(autoPlayer[0].overlay_style) === style.id }"
              @click="autoPlayer[0].overlay_style = style.id"
            >
              <div class="ap-overlay-style-preview" :class="'ap-prev-s' + style.id">
                <div class="ap-prev-card" :class="'ap-prev-card-s' + style.id">
                  <div class="ap-prev-icon">
                    <template v-if="style.id === 7">
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                        <path d="M11 5L6 9H2v6h4l5 4V5z" fill="white"/>
                        <path d="M15.54 8.46a5 5 0 010 7.07" stroke="white" stroke-width="1.8" stroke-linecap="round" opacity="0.45"/>
                        <path d="M19.07 4.93a10 10 0 010 14.14" stroke="white" stroke-width="1.8" stroke-linecap="round" opacity="0.45"/>
                        <line x1="22" y1="2" x2="2" y2="22" stroke="white" stroke-width="2.5" stroke-linecap="round"/>
                      </svg>
                    </template>
                    <template v-else>
                      <svg width="9" height="9" viewBox="0 0 24 24" fill="none">
                        <path d="M11 5L6 9H2v6h4l5 4V5z" fill="white"/>
                        <path d="M15.54 8.46a5 5 0 010 7.07" stroke="white" stroke-width="2.5" stroke-linecap="round"/>
                      </svg>
                    </template>
                  </div>
                  <div class="ap-prev-wave" v-if="style.id !== 7">
                    <span v-for="b in 5" :key="b" class="ap-prev-bar"></span>
                  </div>
                </div>
              </div>
              <div class="ap-overlay-style-name">{{ style.name }}</div>
            </div>
          </div>
        </div>

        <!-- Card: Cores -->
        <div class="ap-section-label">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="#E86A10" stroke-width="2"/><circle cx="12" cy="12" r="4" fill="#E86A10"/></svg>
          Identidade Visual
        </div>

        <div class="ap-card">
          <!-- Cor do Texto -->
          <div class="ap-color-row">
            <div class="ap-color-meta">
              <div class="ap-color-name">Cor do Texto</div>
              <div class="ap-color-sub">Títulos e labels</div>
            </div>
            <label class="ap-color-picker-wrap" :style="'--swatch:' + autoPlayer[0].autoplayer_text_color">
              <span class="ap-color-swatch" :style="'background:' + autoPlayer[0].autoplayer_text_color"></span>
              <span class="ap-color-hex-val">{{ autoPlayer[0].autoplayer_text_color }}</span>
              <svg class="ap-color-edit-icon" width="13" height="13" viewBox="0 0 24 24" fill="none"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" stroke="#94a3b8" stroke-width="2" stroke-linecap="round"/></svg>
              <input type="color" v-model="autoPlayer[0].autoplayer_text_color"
                     @input="previewColors.textColor = $event.target.value"
                     @change="previewColors.textColor = $event.target.value"
                     class="ap-color-native">
            </label>
          </div>

          <div class="ap-card-sep"></div>

          <!-- Cor do Background -->
          <div class="ap-color-row">
            <div class="ap-color-meta">
              <div class="ap-color-name">Cor do Background</div>
              <div class="ap-color-sub">Fundo da tela de início</div>
            </div>
            <label class="ap-color-picker-wrap" :style="'--swatch:' + autoPlayer[0].autoplayer_back_color">
              <span class="ap-color-swatch" :style="'background:' + autoPlayer[0].autoplayer_back_color"></span>
              <span class="ap-color-hex-val">{{ autoPlayer[0].autoplayer_back_color }}</span>
              <svg class="ap-color-edit-icon" width="13" height="13" viewBox="0 0 24 24" fill="none"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" stroke="#94a3b8" stroke-width="2" stroke-linecap="round"/></svg>
              <input type="color" v-model="autoPlayer[0].autoplayer_back_color"
                     @input="previewColors.backColor = $event.target.value"
                     @change="previewColors.backColor = $event.target.value"
                     class="ap-color-native">
            </label>
          </div>

          <div class="ap-card-sep"></div>

          <!-- Cor do Card -->
          <div class="ap-color-row">
            <div class="ap-color-meta">
              <div class="ap-color-name">Cor do Card</div>
              <div class="ap-color-sub">Fundo do card central</div>
            </div>
            <label class="ap-color-picker-wrap" :style="'--swatch:' + (autoPlayer[0].autoplayer_card_color || '#1a1a2e')">
              <span class="ap-color-swatch" :style="'background:' + (autoPlayer[0].autoplayer_card_color || '#1a1a2e')"></span>
              <span class="ap-color-hex-val">{{ autoPlayer[0].autoplayer_card_color || '#1a1a2e' }}</span>
              <svg class="ap-color-edit-icon" width="13" height="13" viewBox="0 0 24 24" fill="none"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" stroke="#94a3b8" stroke-width="2" stroke-linecap="round"/></svg>
              <input type="color" :value="autoPlayer[0].autoplayer_card_color || '#1a1a2e'"
                @input="autoPlayer[0].autoplayer_card_color = $event.target.value" class="ap-color-native">
            </label>
          </div>

          <div class="ap-card-sep"></div>

          <!-- Transparência do Card -->
          <div class="ap-slider-block">
            <div class="ap-slider-block-header">
              <div class="ap-color-name">Transparência do Card</div>
              <span class="ap-range-val">{{ autoPlayer[0].autoplayer_card_opacity != null ? autoPlayer[0].autoplayer_card_opacity : 85 }}%</span>
            </div>
            <input type="range" min="0" max="100"
              :value="autoPlayer[0].autoplayer_card_opacity != null ? autoPlayer[0].autoplayer_card_opacity : 85"
              @input="autoPlayer[0].autoplayer_card_opacity = Number($event.target.value)"
              :style="opacitySliderStyle"
              class="ap-range ap-range-full">
            <div class="ap-color-sub ap-slider-hints">
              <span>0 = invisível</span><span>100 = sólido</span>
            </div>
          </div>
        </div>

        <!-- GIF/Imagem animada (apenas Booster Play - estilo 7) -->
        <template v-if="Number(autoPlayer[0].overlay_style) === 7">
          <div class="ap-section-label">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M17 8l-5-5-5 5M12 3v12" stroke="#E86A10" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
            Imagem / GIF do Icone
          </div>
          <div class="ap-card">
            <div class="ap-gif-upload">
              <p class="ap-color-sub" style="margin-bottom:12px">Substitua o icone padrao por um GIF animado ou imagem. Tamanho recomendado: 120x120px.</p>
              <div class="ap-gif-preview-row">
                <div class="ap-gif-preview" v-if="autoPlayer[0].overlay_gif_url">
                  <img :src="autoPlayer[0].overlay_gif_url" alt="GIF overlay" />
                  <button class="ap-gif-remove" @click="autoPlayer[0].overlay_gif_url = ''; overlayGifPreview = ''" title="Remover">✕</button>
                </div>
                <div class="ap-gif-preview ap-gif-preview--empty" v-else-if="overlayGifPreview">
                  <img :src="overlayGifPreview" alt="Preview" />
                  <button class="ap-gif-remove" @click="overlayGifPreview = ''; overlayGifFile = null" title="Remover">✕</button>
                </div>
                <label class="ap-gif-upload-btn">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M17 8l-5-5-5 5M12 3v12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                  {{ (autoPlayer[0].overlay_gif_url || overlayGifPreview) ? 'Trocar imagem' : 'Enviar GIF ou imagem' }}
                  <input type="file" accept="image/gif,image/png,image/jpeg,image/webp,video/mp4" @change="handleGifUpload" style="display:none" />
                </label>
              </div>
            </div>
          </div>
        </template>

        <!-- Card: Textos -->
        <div class="ap-section-label">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none"><path d="M4 6h16M4 12h16M4 18h7" stroke="#E86A10" stroke-width="2" stroke-linecap="round"/></svg>
          Textos da Tela
        </div>

        <div class="ap-card">
          <div class="ap-text-field">
            <label class="ap-text-label">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" stroke="#94a3b8" stroke-width="2" stroke-linecap="round"/></svg>
              Texto Superior
            </label>
            <textarea
              v-model="autoPlayer[0].autoplayer_top_text"
              class="ap-textarea"
              rows="3"
              placeholder="Ex: Seu vídeo vai começar em..."
            />
          </div>

          <div class="ap-card-sep"></div>

          <div class="ap-text-field">
            <label class="ap-text-label">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none"><path d="M12 22L2 17l10-5 10 5-10 5zM2 7l10 5 10-5M2 12l10 5 10-5" stroke="#94a3b8" stroke-width="2" stroke-linecap="round"/></svg>
              Texto Inferior
            </label>
            <textarea
              v-model="autoPlayer[0].autoplayer_button_text"
              class="ap-textarea"
              rows="3"
              placeholder="Ex: Clique para assistir agora"
            />
          </div>
        </div>

      </div>
    </aside>

    <!-- ═══ PREVIEW ═══ -->
    <main class="ap-preview-area">
      <div class="ap-preview-chrome">
        <div class="ap-chrome-dots">
          <span class="ap-dot ap-dot-red"></span>
          <span class="ap-dot ap-dot-yellow"></span>
          <span class="ap-dot ap-dot-green"></span>
        </div>
        <div class="ap-chrome-title">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="#E86A10" stroke-width="2"/><path d="M10 8l6 4-6 4V8z" fill="#E86A10"/></svg>
          Preview do Player
        </div>
        <span class="ap-live-pill">
          <span class="ap-live-dot"></span>
          AO VIVO
        </span>
      </div>

      <div class="ap-player-wrap">

        <!-- Fundo do player: vídeo real (mudo) ou imagem ou escuro -->
        <video
          v-if="dadosVideo && dadosVideo.URL"
          class="ap-bg-video"
          :src="dadosVideo.URL"
          muted
          autoplay
          loop
          playsinline
        />
        <img
          v-else-if="dadosVideo && dadosVideo.thumb && dadosVideo.thumb.thumbStart"
          class="ap-bg-img"
          :src="dadosVideo.thumb.thumbStart"
          alt="thumb"
        />
        <div v-else class="ap-bg-dark" />

        <!-- Overlay do Auto-Play — prévia em tempo real -->
        <div
          v-if="autoPlayer && autoPlayer[0]"
          class="ap-overlay-live"
          :class="'ap-ol-s' + (autoPlayer[0].overlay_style || 1)"
        >
          <div class="ap-ol-ring ap-ol-ring-1" :class="'ap-ol-ring-s' + (autoPlayer[0].overlay_style || 1)"></div>
          <div class="ap-ol-ring ap-ol-ring-2" :class="'ap-ol-ring-s' + (autoPlayer[0].overlay_style || 1)"></div>

          <div class="ap-ol-card" :class="'ap-ol-card-s' + (autoPlayer[0].overlay_style || 1)" :style="cardPreviewStyle">
            <div class="ap-ol-icon-wrap" :class="'ap-ol-icon-s' + (autoPlayer[0].overlay_style || 1)"
                 :style="iconWrapPreviewStyle">
              <template v-if="Number(autoPlayer[0].overlay_style) === 7 && (autoPlayer[0].overlay_gif_url || overlayGifPreview)">
                <img :src="overlayGifPreview || autoPlayer[0].overlay_gif_url" alt="" style="width:100%;height:100%;object-fit:cover;border-radius:50%;" />
              </template>
              <template v-else-if="Number(autoPlayer[0].overlay_style) === 7">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                  <path d="M15 9.34V4a1 1 0 00-1.64-.77L8.56 7.44H4a1 1 0 00-1 1v7.12a1 1 0 001 1h4.56l4.8 4.21A1 1 0 0015 20v-5.34" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M23 19L17 13M17 19L23 13" stroke="white" stroke-width="2" stroke-linecap="round"/>
                </svg>
              </template>
              <template v-else>
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                  <path d="M11 5L6 9H2v6h4l5 4V5z" fill="white"/>
                  <path d="M15.54 8.46a5 5 0 010 7.07" stroke="white" stroke-width="2" stroke-linecap="round"/>
                  <path d="M19.07 4.93a10 10 0 010 14.14" stroke="white" stroke-width="2" stroke-linecap="round"/>
                </svg>
              </template>
            </div>
            <p class="ap-ol-text-main" :style="'color:' + previewColors.textColor + ' !important'">
              {{ autoPlayer[0].autoplayer_button_text || 'Clique para ouvir' }}
            </p>
            <div class="ap-ol-wave" :class="'ap-ol-wave-s' + (autoPlayer[0].overlay_style || 1)">
              <span v-for="n in 9" :key="n" class="ap-ol-bar"
                :style="{ background: previewColors.backColor }"></span>
            </div>
            <p class="ap-ol-text-sub" :style="'color:' + previewColors.textColor + ' !important'">
              {{ autoPlayer[0].autoplayer_top_text || 'SEU VÍDEO JÁ COMEÇOU' }}
            </p>
          </div>
        </div>

      </div>
    </main>

  </div>
</template>

<script>

import { AutoPlayService } from '@/services/AutoPlay'
import { ControlsService } from '@/services/Controls'
import { BFormCheckbox } from 'bootstrap-vue'

export default {
  components: {
    BFormCheckbox,
  },
  data() {
    return {
      VUE_APP_HOST_API_BACKEND: process.env.VUE_APP_HOST_API_BACKEND || '/api/dkbackend',
      vslId: this.$route.params.vslId,
      loading: false,
      autoPlayer: [],
      dadosVideo: [],
      control: [],
      playx: 'true',
      errorMessage: null,
      overlayStyles: [
        { id: 1, name: 'Glass Premium' },
        { id: 2, name: 'Neon Pulse' },
        { id: 3, name: 'Cinema Dark' },
        { id: 4, name: 'Pill Compact' },
        { id: 5, name: 'Spotlight' },
        { id: 6, name: 'Holografico' },
        { id: 7, name: 'Booster Play' },
      ],
      previewColors: {
        textColor: '#ffffff',
        backColor: '#E86A10',
      },
      overlayGifPreview: '',
      overlayGifFile: null,
    }
  },

  computed: {
    getControls() {
      console.log('oi')
      return this.control
    },
    opacitySliderStyle() {
      if (!this.autoPlayer || !this.autoPlayer[0]) return {};
      const val = this.autoPlayer[0].autoplayer_card_opacity != null
        ? this.autoPlayer[0].autoplayer_card_opacity : 85;
      const pct = Number(val);
      return {
        background: `linear-gradient(to right, #E86A10 0%, #F5B935 ${pct}%, #D1D9E0 ${pct}%)`
      };
    },
    cardPreviewStyle() {
      if (!this.autoPlayer || !this.autoPlayer[0]) return {};
      const ap = this.autoPlayer[0];
      const overlayStyle = Number(ap.overlay_style) || 1;
      const style = {};

      if (overlayStyle === 7) {
        // Style 7 (Booster Play): card usa Cor do Background como fundo
        const hex = this.previewColors.backColor || ap.autoplayer_back_color || '#E86A10';
        const m = hex.match(/^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i);
        const op = ap.autoplayer_card_opacity != null ? ap.autoplayer_card_opacity / 100 : 1;
        if (m) {
          const r = parseInt(m[1], 16), g = parseInt(m[2], 16), b = parseInt(m[3], 16);
          style.background = `rgba(${r},${g},${b},${op})`;
        } else {
          style.background = hex;
        }
        style.backdropFilter = 'none';
        style.webkitBackdropFilter = 'none';
      } else if (ap.autoplayer_card_color) {
        const hex = ap.autoplayer_card_color;
        const op = (ap.autoplayer_card_opacity != null ? ap.autoplayer_card_opacity : 85) / 100;
        const m = hex.match(/^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i);
        if (m) {
          const r = parseInt(m[1], 16), g = parseInt(m[2], 16), b = parseInt(m[3], 16);
          style.background = `rgba(${r},${g},${b},${op})`;
          style.backdropFilter = 'none';
          style.webkitBackdropFilter = 'none';
        }
      } else if (ap.autoplayer_card_opacity != null) {
        // Só slider: controla opacidade geral do card
        style.opacity = ap.autoplayer_card_opacity / 100;
      }

      return style;
    },
    iconWrapPreviewStyle() {
      if (!this.autoPlayer || !this.autoPlayer[0]) return {};
      const ap = this.autoPlayer[0];
      const overlayStyle = Number(ap.overlay_style) || 1;
      // Style 7: icon-wrap semi-transparente (card já usa bgColor como fundo)
      if (overlayStyle === 7) return { background: 'rgba(255,255,255,0.18)' };
      return { background: this.previewColors.backColor || '#E86A10' };
    },
  },
  async created() {
    try {
      this.loading = true
      const response = await AutoPlayService.getAutoPlayVslId(this.vslId)

      this.autoPlayer = response.data

      // Normaliza valores null para que o color picker mostre os defaults corretos
      // (browser usa #000000 para input[type=color] com valor null/inválido,
      //  mas o preview usa fallback branco — causando inconsistência visual)
      if (this.autoPlayer && this.autoPlayer[0]) {
        const ap = this.autoPlayer[0]
        if (!ap.autoplayer_text_color) this.$set(ap, 'autoplayer_text_color', '#ffffff')
        if (!ap.autoplayer_back_color)  this.$set(ap, 'autoplayer_back_color',  '#E86A10')
        if (!ap.autoplayer_button_text) this.$set(ap, 'autoplayer_button_text', 'Clique para ouvir')
        if (!ap.autoplayer_top_text)    this.$set(ap, 'autoplayer_top_text',    'SEU VÍDEO JÁ COMEÇOU')
        // Inicializa previewColors com os valores do banco (garante reatividade de nível raiz)
        this.previewColors.textColor = ap.autoplayer_text_color
        this.previewColors.backColor  = ap.autoplayer_back_color
      }

      const controle = await ControlsService.getControlVSL_Id(this.vslId)
      this.control = controle.data

      this.loading = false
    } catch (error) {
      this.errorMessage = error
      this.loading = false
    }
  },
  beforeMount() {
    this.jsonPersonalizado()
  },
  methods: {

    handleGifUpload(e) {
      const file = e.target.files && e.target.files[0]
      if (!file) return
      this.overlayGifFile = file
      // Preview local imediato
      const reader = new FileReader()
      reader.onload = (ev) => {
        this.overlayGifPreview = ev.target.result
      }
      reader.readAsDataURL(file)

      // Upload para S3 via backend
      const formData = new FormData()
      formData.append('file', file)
      formData.append('vslId', this.vslId)
      formData.append('type', 'overlay_gif')

      this.$http.post(`${this.VUE_APP_HOST_API_BACKEND}/upload-overlay-gif`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      }).then(res => {
        if (res.data && res.data.url) {
          this.autoPlayer[0].overlay_gif_url = res.data.url
          this.$toast({
            component: this.$options.components.ToastificationContent || { render: h => h('span', 'GIF salvo!') },
            props: { title: 'GIF enviado com sucesso!', icon: 'CheckIcon', variant: 'success' },
          })
        }
      }).catch(() => {
        this.$toast({
          component: this.$options.components.ToastificationContent || { render: h => h('span', 'Erro') },
          props: { title: 'Erro ao enviar GIF', icon: 'XIcon', variant: 'danger' },
        })
      })
    },

    jsonPersonalizado() {
      console.log('oi')
      const url = `${this.VUE_APP_HOST_API_BACKEND}/vslsInner/${this.vslId}`
      fetch(url)
        .then(response => response.json())
        .then(data => {
          if (data.status == '1') {
            this.dadosVideo = data.json.find(item => String(item.id) === String(this.vslId))
            console.log(this.dadosVideo)
          }
        })
    },
    updateSubmit() {
      fetch(`${this.VUE_APP_HOST_API_BACKEND}/autoplayer/${this.vslId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          autoplayer_text_color: this.autoPlayer[0].autoplayer_text_color,
          autoplayer_back_color: this.autoPlayer[0].autoplayer_back_color,
          autoplayer_top_text: this.autoPlayer[0].autoplayer_top_text,
          autoplayer_button_text: this.autoPlayer[0].autoplayer_button_text,
          autoplayer_ativo: 1,
          is_layout_default: 0,
          overlay_style: this.autoPlayer[0].overlay_style || 1,
          autoplayer_card_color: this.autoPlayer[0].autoplayer_card_color || null,
          autoplayer_card_opacity: this.autoPlayer[0].autoplayer_card_opacity != null
            ? this.autoPlayer[0].autoplayer_card_opacity : 85,
          id_vsl: this.vslId,
        }),
      })

        .then(response => {
          this.$message({
            type: 'success',
            message: 'Salvo com sucesso',
          })
        })
        .catch(err => console.error(err))
    },

  },

}

</script>
<style scoped>
.tb {
    display: inline-block;
    width: 30px;
    height: 30px;
    margin: 0px;
    border: none;
}

.player {
    max-width: 900px;
    /* //border: 4px solid rgba(0,0,0,.2);
   //box-shadow: 0 0 20px rgba(0,0,0,.2); */
    position: relative;
    font-size: 20;
    overflow: hidden;
}

.player {
    width: 100%;
}

.player:fullcreen {
    max-width: none;
    width: 100%;
}

.player:-webkit-full-screen {
    max-width: none;
    width: 100%;
}

.player:-ms-full-screen {
    max-width: none;
    width: 100%;
}

.player:-moz-full-screen {
    max-width: none;
    width: 100%;
}

.player_my_video {
    min-width: 102%;
    height: 500px;

}

.player_my_controls {
    display: flex;
    position: absolute;
    bottom: 0;
    width: 100%;
    transform: translateY(100%) translateY(-31%);
    transition: all .3s;
    flex-wrap: wrap;
    background: rgba(0, 0, 0, .2);
}

.progress_my_filled {
    width: 80%;
    /* //background: #ffc600; */

    flex: 0;
    flex-basis: 0%;
}

.player:hover .player_my_controls {
    transform: translateY(0);
}

.player_my_controls>* {
    flex: 1;
}

.progress {
    flex: 10;
    position: relative;
    display: flex;
    flex-basis: 100%;

    transition: height .3s;
    background: rgba(0, 0, 0, .25);
    cursor: pointer;
    /* ew-resize*/
}

.player_my_button {
    background: none;
    border: 0;
    line-height: 1;
    color: white;
    text-align: center;
    outline: 0;
    padding: 10px 15px 10px 15px;
    cursor: pointer;
    max-width: 50px;

}

.playerSlider {
    display: block;
    width: 10px;
    height: 30px;
}

input[type=range] {
    -webkit-appearance: none !important;
    background: transparent;
    width: 100%;
    margin: 0 5px;
}

input[type=range]::-webkit-slider-runnable-track {
    width: 100%;
    height: 2px;
    cursor: pointer;
    box-shadow: 1px 1px 1px rgba(0, 0, 0, 0), 0 0 1px rgba(13, 13, 13, 0);
    background: rgba(255, 255, 255, .8);
    border-radius: 1.3px;
    border: 0.2px solid rgba(1, 1, 1, 0)
}

input[type=range]::-webkit-slider-thumb {
    height: 10px;
    width: 10px;
    border-radius: 50px;
    background: var(--dk-bg-card, #fff);
    cursor: pointer;
    -webkit-appearance: none;
    margin-top: -4px;
    box-shadow: 0 0 2px rgba(0, 0, 0, .2);
}

input[type=range]:focus {
    outline: none;

}

input[type=range]:focus::-webkit-slider-runnable-track {
    background: #ff0;

}

/* Mozila Linha do volume*/

input[type=range]::-moz-range-track {
    width: 100%;
    height: 0.1px;
    cursor: pointer;
    box-shadow: 1px 1px 1px rgba(0, 0, 0, 0), 0 0 1px rgba(13, 13, 13, 0);
    background: var(--dk-bg-card, #fff);
    border-radius: 1.3px;
    border: 0.2px solid rgba(1, 1, 1, 0)
}

/* Mozila Circulo do volume*/

input[type=range]::-moz-range-thumb {
    height: 10px;
    width: 10px;
    border-radius: 50px;
    border-color: none;
    background: var(--dk-bg-card, #fff);
    cursor: pointer;
}

.fullscreenbtn {

    margin-left: 75%;
    border: 0;
    line-height: 1;
    color: white;
    text-align: center;
    align-content: stretch;
    outline: 0;
    cursor: pointer;
    max-width: 4px;
}

.button_volume {

    margin-left: -2%;
    border: 0;
    line-height: 1;
    color: white;
    text-align: center;
    align-content: stretch;
    outline: 0;
    cursor: pointer;
    max-width: 4px;
}

.PictureInPicture {
    margin-left: -9%;
    border: 0;
    line-height: 1;
    color: white;
    text-align: center;
    align-content: stretch;
    outline: 0;
    cursor: pointer;
    max-width: 4px;
}

.playpause {

    border-radius: 50px;
    background-image: url(../img/play.svg);
    background-repeat: no-repeat;
    width: 100px;
    height: 100px;
    position: absolute;
    left: 0%;
    right: 0%;
    top: 0%;
    bottom: 0%;
    margin: auto;
    background-size: contain;
    background-position: center;
    cursor: pointer;
    z-index: 10 !important;
}

.playpause {
    opacity: 1;
    transition: opacity 400ms;
}

.playpause[hidden] {
    opacity: 0;

}

.iniciar {
    border: 2px solid;
    border-style: none;
    border-radius: 15px 50px;
    display: block;
    width: 50%;
    height: 50%;
    position: absolute;
    flex-direction: column-reverse;
    display: flex;
    left: 0%;
    right: 0%;
    top: 0%;
    bottom: 0%;
    margin: auto;
    align-items: center;
    background-size: contain;
    background-position: center;

}

.nome_principal {
    display: inline-flex;
    align-items: center;
    margin-left: 7px;
    padding: 2px;
}

.video-banner {
    position: relative;
}

.video-banner .overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
    z-index: 1;
}

.loader {
    height: 70px;
    width: 200px;
    display: flex;
    align-items: center;
}

.loader .stroke {
    display: block;
    position: relative;
    background: var(--dk-bg-inset, #f1f1f1);
    height: 50%;
    width: 15%;
    border-radius: 50px;
    margin: 0 5px;
    align-items: center;
    animation: animate 1.2s linear infinite;
}

/* .playImagem {
    width: 64px;
    height: 64px;
    cursor: pointer;
  } */

h2 {
    position: relative;
    align-self: center;
    font-family: Arial, Helvetica, sans-serif;
}

@keyframes animate {
    50% {
        height: 20%;
    }

    100% {
        height: 100%;
    }
}

.stroke:nth-child(1) {
    animation-delay: 0s;
}

.stroke:nth-child(2) {
    animation-delay: 0.3s;
}

.stroke:nth-child(3) {
    animation-delay: 0.6s;
}

.stroke:nth-child(4) {
    animation-delay: 0.9s;
}

.stroke:nth-child(5) {
    animation-delay: 0.6s;
}

.stroke:nth-child(6) {
    animation-delay: 0;
}

.stroke:nth-child(7) {
    animation-delay: 0.2s;
}

.stroke:nth-child(8) {
    animation-delay: 0.5s;
}

.stroke:nth-child(9) {
    animation-delay: 0.1s;
}

.stroke:nth-child(10) {
    animation-delay: 0s;
}

.stroke:nth-child(11) {
    animation-delay: 0.3s;
}

.stroke:nth-child(12) {
    animation-delay: 0.6s;
}

.stroke:nth-child(13) {
    animation-delay: 0.3s;
}

#context-menu {
    position: fixed;
    width: 170px;
    height: 20px;
    border: #000;
    background: rgba(40, 38, 38, 0.856);
    transform: scale(0);
    transform-origin: top left;
    padding: 8px 8px 8px 8px;
}

#context-menu.active {
    transform: scale(1);
    transition: transform 200ms ease-in-out;
}

#context-menu a {
    font-size: 15px;
    font-family: Arial, Helvetica, sans-serif;
    color: #eee;
    text-decoration: none;
}

#context-menu .item:hover {
    background: #555;
}

.playpausebg {

    background-repeat: no-repeat;
    width: 102%;
    height: 128%;
    position: absolute;
    left: 0%;
    right: 0%;
    top: 0%;
    bottom: 0%;
    margin: auto;
    background-size: contain;
    background-position: center;
    cursor: pointer;
    z-index: 2 !important;
}

.playpausebg {
    opacity: 1;
    transition: opacity 400ms;
}

.playpausebg[hidden] {
    opacity: 0;

}

.playEndedbg {

    background-repeat: no-repeat;
    width: 102%;
    height: 128%;
    position: absolute;
    left: 0%;
    right: 0%;
    top: 0%;
    bottom: 0%;
    margin: auto;
    background-size: contain;
    background-position: center;
    cursor: pointer;
    z-index: 2 !important;
}

.playEndedbg {
    opacity: 1;
    transition: opacity 400ms;
}

.playEndedbg[hidden] {
    opacity: 0;
}

/* ===================== AP BRAND STYLES ===================== */
.ap-root {
  display: flex;
  flex-direction: row;
  height: calc(100vh - 80px);
  width: 100%;
  overflow: hidden;
  background: var(--dk-bg-segment, #F0F3F7);
  font-family: -apple-system, BlinkMacSystemFont, 'Inter', 'Segoe UI', sans-serif;
  box-sizing: border-box;
  --dk-bg-segment:     rgba(255,255,255,0.04);
  --dk-bg-card:        rgba(255,255,255,0.05);
  --dk-bg-page:        rgba(255,255,255,0.04);
  --dk-border:         rgba(255,255,255,0.09);
  --dk-border-light:   rgba(255,255,255,0.07);
  --dk-text-primary:   #e2e8f0;
  --dk-text-secondary: rgba(255,255,255,0.6);
  --dk-text-muted:     rgba(255,255,255,0.4);
  --dk-text-faint:     rgba(255,255,255,0.25);
}

/* ── Sidebar ── */
.ap-sidebar {
  width: 308px;
  min-width: 280px;
  max-width: 320px;
  flex-shrink: 0;
  background: var(--dk-bg-card, #fff);
  border-right: 1px solid var(--dk-border, #E4EAF0);
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
  box-shadow: 2px 0 16px rgba(0,0,0,0.3);
}

/* Header */
.ap-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 22px 20px 18px;
  border-bottom: 1px solid var(--dk-border-light, #F0F3F7);
}
.ap-header-icon {
  width: 42px; height: 42px;
  border-radius: 12px;
  background: rgba(232,106,16,0.10);
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}
.ap-header-text { flex: 1; min-width: 0; }
.ap-header-title {
  font-size: 14px;
  font-weight: 700;
  color: var(--dk-text-primary, #0D3349);
  line-height: 1.2;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.ap-header-sub {
  font-size: 11px;
  color: var(--dk-text-muted, #94a3b8);
  margin-top: 2px;
}
.ap-status-badge {
  flex-shrink: 0;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.06em;
  padding: 3px 9px;
  border-radius: 20px;
}
.ap-badge-on { background: rgba(16,185,129,0.15); color: #34d399; }
.ap-badge-off { background: var(--dk-bg-segment, #F0F3F7); color: var(--dk-text-muted, #94a3b8); }

/* Actions */
.ap-actions {
  display: flex;
  gap: 8px;
  padding: 14px 16px;
  border-bottom: 1px solid var(--dk-border-light, #F0F3F7);
}
.ap-btn-save {
  flex: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  background: #E86A10 !important;
  background-image: none !important;
  color: #fff !important;
  border: none;
  border-radius: 10px;
  padding: 10px 14px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 2px 10px rgba(232,106,16,0.30);
  transition: all 0.18s;
}
.ap-btn-save:hover { background: #c85a08 !important; box-shadow: 0 4px 16px rgba(232,106,16,0.40); transform: translateY(-1px); }
.ap-btn-back {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  background: var(--dk-bg-segment, #F4F6F9) !important;
  background-image: none !important;
  color: var(--dk-text-secondary, #64748b) !important;
  border: 1.5px solid var(--dk-border, #E4EAF0);
  border-radius: 10px;
  padding: 10px 16px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none !important;
  transition: all 0.15s;
  white-space: nowrap;
}
.ap-btn-back:hover { background: rgba(255,255,255,0.08) !important; color: #e2e8f0 !important; text-decoration: none !important; }

/* Body */
.ap-body {
  padding: 16px;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0;
}

/* Section label */
.ap-section-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 10.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.09em;
  color: var(--dk-text-muted, #94a3b8);
  margin: 14px 0 8px;
}
.ap-section-label:first-child { margin-top: 4px; }

/* Card */
.ap-card {
  background: var(--dk-bg-card, #fff);
  border: 1.5px solid var(--dk-border, #E4EAF0);
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 4px;
}
.ap-card-sep {
  height: 1px;
  background: var(--dk-bg-segment, #F0F3F7);
}

/* Toggle row */
.ap-toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  gap: 12px;
}
.ap-toggle-info { flex: 1; min-width: 0; }
.ap-toggle-label {
  font-size: 13px;
  font-weight: 600;
  color: var(--dk-text-primary, #0D3349);
}
.ap-toggle-sub {
  font-size: 11.5px;
  color: var(--dk-text-muted, #94a3b8);
  margin-top: 2px;
}

/* Switch toggle */
.ap-switch {
  position: relative;
  flex-shrink: 0;
  cursor: pointer;
}
.ap-switch input { position: absolute; opacity: 0; width: 0; height: 0; }
.ap-switch-track {
  display: block;
  width: 46px; height: 26px;
  background: rgba(255,255,255,0.15);
  border-radius: 26px;
  position: relative;
  transition: background 0.25s;
}
.ap-switch input:checked ~ .ap-switch-track { background: #E86A10; }
.ap-switch-thumb {
  position: absolute;
  top: 3px; left: 3px;
  width: 20px; height: 20px;
  background: var(--dk-bg-card, #fff);
  border-radius: 50%;
  box-shadow: 0 1px 4px rgba(0,0,0,0.20);
  transition: transform 0.25s cubic-bezier(.4,0,.2,1);
}
.ap-switch input:checked ~ .ap-switch-track .ap-switch-thumb { transform: translateX(20px); }

/* Color picker rows */
.ap-color-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 13px 16px;
  gap: 12px;
}
.ap-slider-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 13px 16px;
  gap: 12px;
}
.ap-slider-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

/* Slider em bloco vertical (transparência) */
.ap-slider-block {
  padding: 13px 16px 11px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  box-sizing: border-box;
  width: 100%;
}
.ap-slider-block-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.ap-range-full {
  width: 100%;
  box-sizing: border-box;
}
.ap-slider-hints {
  display: flex;
  justify-content: space-between;
  font-size: 10px;
  color: var(--dk-text-muted, #94a3b8);
  margin-top: -2px;
}
.ap-range {
  -webkit-appearance: none;
  appearance: none;
  width: 90px;
  height: 6px;
  border-radius: 6px;
  background: rgba(255,255,255,0.15);
  outline: none;
  cursor: pointer;
  flex-shrink: 0;
}
.ap-range::-webkit-slider-runnable-track {
  height: 6px;
  border-radius: 6px;
  background: transparent;
}
.ap-range::-moz-range-track {
  height: 6px;
  border-radius: 6px;
  background: transparent;
  border: none;
}
.ap-range::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 18px; height: 18px;
  margin-top: -6px;
  border-radius: 50%;
  background: #E86A10;
  box-shadow: 0 1px 5px rgba(0,0,0,0.3);
  cursor: pointer;
  border: 2px solid var(--dk-bg-card, #fff);
}
.ap-range::-moz-range-thumb {
  width: 18px; height: 18px;
  border-radius: 50%;
  background: #E86A10;
  border: 2px solid var(--dk-bg-card, #fff);
  box-shadow: 0 1px 5px rgba(0,0,0,0.3);
  cursor: pointer;
}
.ap-range-val {
  font-size: 12px;
  font-weight: 700;
  color: #E86A10;
  min-width: 38px;
  text-align: right;
  flex-shrink: 0;
}
.ap-color-meta { flex: 1; min-width: 0; overflow: hidden; }
.ap-color-name {
  font-size: 13px;
  font-weight: 600;
  color: var(--dk-text-primary, #0D3349);
}
.ap-color-sub {
  font-size: 11px;
  color: var(--dk-text-muted, #94a3b8);
  margin-top: 1px;
}
.ap-color-picker-wrap {
  display: flex;
  align-items: center;
  gap: 6px;
  background: var(--dk-bg-page, #F8FAFB);
  border: 1.5px solid var(--dk-border, #E4EAF0);
  border-radius: 9px;
  padding: 6px 9px;
  cursor: pointer;
  position: relative;
  transition: border-color 0.15s, box-shadow 0.15s;
  flex-shrink: 0;
  max-width: 128px;
  overflow: hidden;
}
.ap-color-picker-wrap:hover {
  border-color: #E86A10;
  box-shadow: 0 0 0 3px rgba(232,106,16,0.10);
}
.ap-color-swatch {
  width: 22px; height: 22px;
  border-radius: 6px;
  border: 1.5px solid rgba(0,0,0,0.08);
  display: block;
  flex-shrink: 0;
}
.ap-color-hex-val {
  font-size: 11px;
  font-family: 'Courier New', monospace;
  font-weight: 600;
  color: var(--dk-text-secondary, #475569);
  letter-spacing: 0.03em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 60px;
}
.ap-color-edit-icon { opacity: 0.45; flex-shrink: 0; }
.ap-color-native {
  position: absolute;
  opacity: 0;
  width: 100%; height: 100%;
  top: 0; left: 0;
  cursor: pointer;
  border: none; padding: 0;
}

/* Text fields */
.ap-text-field {
  padding: 14px 16px;
}
.ap-text-label {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 11.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: var(--dk-text-muted, #94a3b8);
  margin-bottom: 8px;
}
.ap-textarea {
  width: 100%;
  border: 1.5px solid var(--dk-border, #E4EAF0);
  border-radius: 9px;
  padding: 10px 12px;
  font-size: 13px;
  color: var(--dk-text-primary, #0D3349);
  background: var(--dk-bg-page, #F8FAFB);
  resize: vertical;
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;
  font-family: inherit;
  line-height: 1.5;
}
.ap-textarea:focus {
  border-color: #E86A10;
  background: var(--dk-bg-card, #fff);
  box-shadow: 0 0 0 3px rgba(232,106,16,0.10);
}
.ap-textarea::placeholder { color: var(--dk-text-faint, #c0c8d4); }

/* Disabled hint */
.ap-disabled-hint {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 32px 16px;
  text-align: center;
  color: var(--dk-text-faint, #b0bec8);
  font-size: 12.5px;
  line-height: 1.6;
}
.ap-disabled-hint strong { color: var(--dk-text-secondary, #64748b); }

/* Fade transition */
.ap-fade-enter-active, .ap-fade-leave-active { transition: opacity 0.25s, transform 0.25s; }
.ap-fade-enter, .ap-fade-leave-to { opacity: 0; transform: translateY(6px); }

/* ── Preview Area ── */
.ap-preview-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 16px 20px;
  background: var(--dk-bg-segment, #F0F3F7);
  min-width: 0;
  overflow: hidden;
  box-sizing: border-box;
}

/* Chrome bar */
.ap-preview-chrome {
  display: flex;
  align-items: center;
  gap: 10px;
  background: var(--dk-bg-card, #fff);
  border: 1.5px solid var(--dk-border, #E4EAF0);
  border-bottom: none;
  border-radius: 12px 12px 0 0;
  padding: 10px 16px;
}
.ap-chrome-dots { display: flex; gap: 6px; align-items: center; }
.ap-dot {
  width: 11px; height: 11px;
  border-radius: 50%;
  display: block;
}
.ap-dot-red    { background: #ff5f57; }
.ap-dot-yellow { background: #febc2e; }
.ap-dot-green  { background: #28c840; }
.ap-chrome-title {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 11.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: var(--dk-text-muted, #94a3b8);
  flex: 1;
}
.ap-live-pill {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  color: #34d399;
  background: rgba(16,185,129,0.15);
  padding: 3px 9px;
  border-radius: 20px;
}
.ap-live-dot {
  width: 7px; height: 7px;
  border-radius: 50%;
  background: #34d399;
  animation: ap-pulse 1.4s ease-in-out infinite;
}
@keyframes ap-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.3; }
}

/* Player container — preenche toda a altura disponível */
.ap-player-wrap {
  flex: 1;
  min-height: 0;
  background: #0a1520;
  border-radius: 0 0 12px 12px;
  overflow: hidden;
  border: 1.5px solid var(--dk-border, #E4EAF0);
  border-top: none;
  box-shadow: 0 12px 40px rgba(0,0,0,0.4);
  position: relative;
}

/* Fundo vídeo / imagem / escuro */
.ap-bg-video,
.ap-bg-img,
.ap-bg-dark {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 0;
}
.ap-bg-dark {
  background: #0a1520;
}

/* ══════════════════════════════════════════
   LIVE OVERLAY PREVIEW — 6 Estilos Premium
   ══════════════════════════════════════════ */

/* Base container */
.ap-overlay-live {
  position: absolute; inset: 0;
  display: flex; align-items: center; justify-content: center;
  z-index: 10; cursor: pointer; overflow: hidden;
}

/* ── Rings de fundo (decorativos) ── */
.ap-ol-ring {
  position: absolute; border-radius: 50%;
  pointer-events: none; opacity: 0;
}
.ap-ol-ring-s2.ap-ol-ring-1 {
  width: 120px; height: 120px;
  border: 1.5px solid rgba(255,255,255,0.08);
  opacity: 1; animation: ap-ring-pulse 2.5s ease-out infinite;
}
.ap-ol-ring-s2.ap-ol-ring-2 {
  width: 180px; height: 180px;
  border: 1px solid rgba(255,255,255,0.05);
  opacity: 1; animation: ap-ring-pulse 2.5s ease-out infinite 0.8s;
}
.ap-ol-ring-s5.ap-ol-ring-1 {
  width: 100px; height: 100px;
  border: 2px solid rgba(255,255,255,0.12);
  opacity: 1; animation: ap-ring-pulse 2s ease-out infinite;
}
.ap-ol-ring-s5.ap-ol-ring-2 {
  width: 160px; height: 160px;
  border: 1.5px solid rgba(255,255,255,0.06);
  opacity: 1; animation: ap-ring-pulse 2s ease-out infinite 0.7s;
}
.ap-ol-ring-s6.ap-ol-ring-1 {
  width: 110px; height: 110px;
  border: 2px solid rgba(150,100,255,0.25);
  opacity: 1; animation: ap-ring-pulse 2.2s ease-out infinite;
}
.ap-ol-ring-s6.ap-ol-ring-2 {
  width: 170px; height: 170px;
  border: 1.5px solid rgba(100,150,255,0.15);
  opacity: 1; animation: ap-ring-pulse 2.2s ease-out infinite 0.7s;
}
@keyframes ap-ring-pulse {
  0% { transform: scale(0.9); opacity: 0.7; }
  100% { transform: scale(1.35); opacity: 0; }
}

/* ── Shared card base ── */
.ap-ol-card {
  display: flex; flex-direction: column; align-items: center;
  gap: 10px; text-align: center;
  position: relative; z-index: 2;
}

/* ── Speaker icon ── */
.ap-ol-icon-wrap {
  width: 48px; height: 48px; border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 4px 20px rgba(0,0,0,0.4);
  transition: transform 0.2s;
}
.ap-ol-icon-wrap:hover { transform: scale(1.05); }

/* ── Waveform ── */
.ap-ol-wave {
  display: flex; align-items: center; gap: 2.5px; height: 22px;
}
.ap-ol-bar {
  width: 3px; border-radius: 2px; background: #E86A10;
  animation: ap-wave-bar 1.1s ease-in-out infinite;
  transform-origin: bottom;
}
.ap-ol-bar:nth-child(1) { height: 6px;  animation-delay: 0s; }
.ap-ol-bar:nth-child(2) { height: 10px; animation-delay: 0.1s; }
.ap-ol-bar:nth-child(3) { height: 16px; animation-delay: 0.2s; }
.ap-ol-bar:nth-child(4) { height: 20px; animation-delay: 0.05s; }
.ap-ol-bar:nth-child(5) { height: 22px; animation-delay: 0.15s; }
.ap-ol-bar:nth-child(6) { height: 20px; animation-delay: 0.25s; }
.ap-ol-bar:nth-child(7) { height: 16px; animation-delay: 0.1s; }
.ap-ol-bar:nth-child(8) { height: 10px; animation-delay: 0.2s; }
.ap-ol-bar:nth-child(9) { height: 6px;  animation-delay: 0.05s; }
@keyframes ap-wave-bar {
  0%, 100% { transform: scaleY(0.35); opacity: 0.6; }
  50% { transform: scaleY(1); opacity: 1; }
}

/* ── Texts ── */
.ap-ol-text-main {
  margin: 0; padding: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: 13px; font-weight: 700; line-height: 1.3; color: #fff;
}
.ap-ol-text-sub {
  margin: 0; padding: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: 9px; font-weight: 600; letter-spacing: 0.06em;
  text-transform: uppercase; color: #fff; opacity: 0.75;
}

/* ══════════════════════
   STYLE 1 — Glass Premium
   (Como na imagem de referência)
   ══════════════════════ */
.ap-ol-s1 {
  background: rgba(0,0,0,0.48);
  backdrop-filter: blur(3px); -webkit-backdrop-filter: blur(3px);
}
.ap-ol-card-s1 {
  padding: 20px 36px 18px;
  background: rgba(255,255,255,0.09);
  backdrop-filter: blur(28px); -webkit-backdrop-filter: blur(28px);
  border-radius: 20px;
  border: 1px solid rgba(255,255,255,0.18);
  box-shadow: 0 8px 40px rgba(0,0,0,0.5), inset 0 1px 0 rgba(255,255,255,0.15);
  width: 78%; min-width: 200px;
}
.ap-ol-icon-s1 {
  width: 52px; height: 52px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.4), 0 0 0 6px rgba(255,255,255,0.1);
}

/* ══════════════════════
   STYLE 2 — Neon Pulse
   ══════════════════════ */
.ap-ol-s2 { background: rgba(0,0,0,0.82); }
.ap-ol-card-s2 {
  padding: 20px 36px 18px;
  background: rgba(15,15,20,0.95);
  border-radius: 12px;
  border: 1px solid rgba(255,255,255,0.12);
  box-shadow: 0 0 0 1px rgba(255,255,255,0.06), 0 8px 32px rgba(0,0,0,0.6);
  width: 78%; min-width: 200px;
}
.ap-ol-icon-s2 {
  box-shadow: 0 0 20px var(--accent, rgba(232,106,16,0.6)), 0 4px 16px rgba(0,0,0,0.4);
  animation: ap-icon-pulse 2s ease-in-out infinite;
}
@keyframes ap-icon-pulse {
  0%, 100% { box-shadow: 0 0 16px rgba(232,106,16,0.5), 0 4px 16px rgba(0,0,0,0.4); }
  50% { box-shadow: 0 0 32px rgba(232,106,16,0.85), 0 0 60px rgba(232,106,16,0.3), 0 4px 16px rgba(0,0,0,0.4); }
}

/* ══════════════════════
   STYLE 3 — Cinema Dark
   (Tela inteira imersiva)
   ══════════════════════ */
.ap-ol-s3 { background: rgba(0,0,0,0.88); flex-direction: column; }
.ap-ol-card-s3 {
  padding: 0; background: transparent; border: none;
  gap: 14px; width: 85%;
}
.ap-ol-icon-s3 {
  width: 60px; height: 60px;
  box-shadow: 0 6px 30px rgba(0,0,0,0.5), 0 0 0 10px rgba(255,255,255,0.06);
}
.ap-ol-card-s3 .ap-ol-text-main {
  font-size: 15px; letter-spacing: 0.02em;
  text-shadow: 0 2px 12px rgba(0,0,0,0.8);
}
.ap-ol-card-s3 .ap-ol-text-sub {
  letter-spacing: 0.18em; font-size: 9px;
  text-shadow: 0 1px 8px rgba(0,0,0,0.8);
}

/* ══════════════════════
   STYLE 4 — Pill Compact
   (Canto inferior)
   ══════════════════════ */
.ap-ol-s4 {
  background: transparent;
  align-items: flex-end; justify-content: center;
  padding-bottom: 14px;
}
.ap-ol-card-s4 {
  flex-direction: row; gap: 10px;
  padding: 10px 16px 10px 12px;
  background: rgba(10,10,15,0.88);
  backdrop-filter: blur(20px); -webkit-backdrop-filter: blur(20px);
  border-radius: 100px;
  border: 1px solid rgba(255,255,255,0.14);
  box-shadow: 0 4px 24px rgba(0,0,0,0.5);
  min-width: auto; max-width: 88%;
}
.ap-ol-card-s4 .ap-ol-text-main { font-size: 10px; white-space: nowrap; }
.ap-ol-card-s4 .ap-ol-text-sub { display: none; }
.ap-ol-card-s4 .ap-ol-wave { height: 16px; }
.ap-ol-card-s4 .ap-ol-bar { width: 2.5px; }
.ap-ol-card-s4 .ap-ol-bar:nth-child(n+8) { display: none; }
.ap-ol-icon-s4 { width: 32px; height: 32px; }
.ap-ol-icon-s4 svg { width: 15px; height: 15px; }

/* ══════════════════════
   STYLE 5 — Gradient Spotlight
   ══════════════════════ */
.ap-ol-s5 {
  background: radial-gradient(ellipse at 50% 50%, rgba(0,0,0,0.90) 0%, rgba(0,0,0,0.55) 55%, rgba(0,0,0,0.25) 100%);
}
.ap-ol-card-s5 {
  padding: 20px 36px 18px;
  background: transparent; border: none;
  gap: 12px; width: 78%; min-width: 200px;
}
.ap-ol-icon-s5 {
  width: 56px; height: 56px;
  box-shadow: 0 6px 32px rgba(0,0,0,0.4);
}
.ap-ol-card-s5 .ap-ol-text-main {
  text-shadow: 0 2px 16px rgba(0,0,0,0.9);
  font-size: 14px;
}
.ap-ol-card-s5 .ap-ol-text-sub {
  text-shadow: 0 1px 8px rgba(0,0,0,0.9);
}

/* ══════════════════════
   STYLE 6 — Holographic Float
   ══════════════════════ */
.ap-ol-s6 { background: rgba(0,0,0,0.58); }
.ap-ol-card-s6 {
  padding: 20px 36px 18px;
  background: linear-gradient(145deg, rgba(25,20,50,0.95) 0%, rgba(10,15,40,0.98) 100%);
  backdrop-filter: blur(20px); -webkit-backdrop-filter: blur(20px);
  border-radius: 22px;
  border: 1px solid transparent;
  background-clip: padding-box;
  box-shadow:
    0 0 0 1px rgba(180,130,255,0.25),
    0 0 30px rgba(100,80,255,0.2),
    0 12px 40px rgba(0,0,0,0.6),
    inset 0 1px 0 rgba(255,255,255,0.1);
  width: 78%; min-width: 200px;
  animation: ap-float 3s ease-in-out infinite;
}
.ap-ol-icon-s6 {
  box-shadow: 0 0 20px rgba(180,130,255,0.5), 0 4px 16px rgba(0,0,0,0.4);
  animation: ap-icon-holo 3s ease-in-out infinite;
}
@keyframes ap-icon-holo {
  0%, 100% { box-shadow: 0 0 16px rgba(150,100,255,0.5), 0 4px 16px rgba(0,0,0,0.4); }
  50% { box-shadow: 0 0 28px rgba(100,180,255,0.7), 0 0 50px rgba(150,100,255,0.3), 0 4px 16px rgba(0,0,0,0.4); }
}
@keyframes ap-float {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-7px); }
}

/* ── Overlay Style Selector ── */
.ap-overlay-styles {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}
.ap-overlay-style-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  border-radius: 10px;
  padding: 8px 6px 6px;
  border: 2px solid var(--dk-border, #E4EAF0);
  transition: all 0.15s;
}
.ap-overlay-style-item:hover {
  border-color: #E86A10;
  background: rgba(232,106,16,0.04);
}
.ap-overlay-style-active {
  border-color: #E86A10 !important;
  background: rgba(232,106,16,0.08) !important;
  box-shadow: 0 0 0 2px rgba(232,106,16,0.18);
}
.ap-overlay-style-preview {
  width: 100%;
  aspect-ratio: 16/9;
  border-radius: 6px;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ap-overlay-style-name {
  font-size: 10px;
  font-weight: 600;
  color: var(--dk-text-secondary, #64748b);
  text-align: center;
}
.ap-overlay-style-active .ap-overlay-style-name {
  color: #E86A10;
}

/* ── Shared thumbnail parts ── */
.ap-prev-card {
  display: flex; flex-direction: column;
  align-items: center; justify-content: center;
  gap: 4px;
}
.ap-prev-icon {
  width: 18px; height: 18px; border-radius: 50%;
  background: #E86A10;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 2px 6px rgba(232,106,16,0.5);
}
.ap-prev-wave {
  display: flex; align-items: center; gap: 1.5px; height: 10px;
}
.ap-prev-bar {
  width: 2px; border-radius: 1px; background: #E86A10;
}
.ap-prev-bar:nth-child(1) { height: 3px; }
.ap-prev-bar:nth-child(2) { height: 6px; }
.ap-prev-bar:nth-child(3) { height: 10px; }
.ap-prev-bar:nth-child(4) { height: 6px; }
.ap-prev-bar:nth-child(5) { height: 3px; }

/* Thumbnail — Style 1: Glass Premium */
.ap-prev-s1 {
  background: rgba(0,0,0,0.5);
  backdrop-filter: blur(2px);
}
.ap-prev-card-s1 {
  width: 56%; height: 68%; border-radius: 10px;
  background: rgba(255,255,255,0.1);
  border: 1px solid rgba(255,255,255,0.2);
  box-shadow: 0 4px 12px rgba(0,0,0,0.5), inset 0 1px 0 rgba(255,255,255,0.15);
}

/* Thumbnail — Style 2: Neon Pulse */
.ap-prev-s2 { background: rgba(0,0,0,0.85); }
.ap-prev-card-s2 {
  width: 56%; height: 68%; border-radius: 7px;
  background: rgba(10,10,16,0.97);
  border: 1px solid rgba(255,255,255,0.1);
  box-shadow: 0 0 10px rgba(232,106,16,0.3);
}

/* Thumbnail — Style 3: Cinema Dark */
.ap-prev-s3 { background: rgba(0,0,0,0.88); }
.ap-prev-card-s3 {
  width: 90%; height: 85%; border-radius: 3px;
  background: transparent; border: none;
}

/* Thumbnail — Style 4: Pill Compact */
.ap-prev-s4 {
  background: linear-gradient(180deg, rgba(40,40,50,0.7) 0%, rgba(20,20,30,0.7) 100%);
  align-items: flex-end !important; justify-content: center !important;
  padding-bottom: 6px !important;
}
.ap-prev-card-s4 {
  flex-direction: row !important;
  width: 80%; height: auto !important; border-radius: 30px;
  background: rgba(8,8,14,0.90);
  border: 1px solid rgba(255,255,255,0.12);
  padding: 4px 8px; gap: 4px;
}
.ap-prev-card-s4 .ap-prev-wave { height: 8px; }

/* Thumbnail — Style 5: Gradient Spotlight */
.ap-prev-s5 {
  background: radial-gradient(ellipse at center, rgba(0,0,0,0.92) 0%, rgba(0,0,0,0.5) 60%, rgba(50,50,60,0.4) 100%);
}
.ap-prev-card-s5 {
  width: 60%; height: 72%; border-radius: 0;
  background: transparent; border: none; box-shadow: none;
}

/* Thumbnail — Style 6: Holographic Float */
.ap-prev-s6 { background: rgba(0,0,0,0.6); }
.ap-prev-card-s6 {
  width: 58%; height: 70%; border-radius: 12px;
  background: linear-gradient(145deg, rgba(22,16,48,0.96) 0%, rgba(8,12,38,0.99) 100%);
  box-shadow: 0 0 0 1px rgba(180,130,255,0.3), 0 0 14px rgba(100,80,255,0.3);
}
.ap-prev-card-s6 .ap-prev-icon {
  box-shadow: 0 0 8px rgba(180,130,255,0.7);
}

/* ── Style 7: Booster Play ─────────────────────────── */
/* Live overlay */
.ap-ol-s7 { background: rgba(0,0,0,0.45); overflow: visible !important; }
.ap-ol-card-s7 {
  padding: 28px 40px 28px;
  border-radius: 20px;
  border: none;
  box-shadow: 0 20px 64px rgba(0,0,0,0.45);
  width: 58%; min-width: 240px; max-width: 420px;
  position: relative; overflow: visible;
  gap: 14px;
  backdrop-filter: none !important; -webkit-backdrop-filter: none !important;
}
.ap-ol-card-s7::before { display: none; }
.ap-ol-icon-s7 {
  width: 76px; height: 76px;
  background: rgba(255,255,255,0.18) !important;
  box-shadow: none !important;
  border: none !important;
  border-radius: 50% !important;
}
.ap-ol-wave-s7 { display: none; }
.ap-ol-ring-s7 { display: none; }
.ap-ol-s7 .ap-ol-text-sub  { order: -2; font-size: 16px; font-weight: 800; text-transform: none; letter-spacing: 0; opacity: 1; }
.ap-ol-s7 .ap-ol-icon-wrap { order: -1; }
.ap-ol-s7 .ap-ol-text-main { order:  0; font-size: 14px; font-weight: 700; letter-spacing: 0.3px; opacity: 0.92; }

/* Thumbnail preview */
.ap-prev-s7 { background: #2a2a2a; }
.ap-prev-card-s7 {
  width: 58%; height: 62%; border-radius: 8px;
  background: #E86A10;
  box-shadow: 0 8px 20px rgba(0,0,0,0.4);
  position: relative; overflow: visible;
}
.ap-prev-card-s7::before { display: none; }
.ap-prev-card-s7 .ap-prev-icon {
  background: rgba(255,255,255,0.2);
  border: none;
  border-radius: 50%;
  width: 18px; height: 18px;
}

/* GIF Upload */
.ap-gif-upload { }
.ap-gif-preview-row { display: flex; align-items: center; gap: 16px; flex-wrap: wrap; }
.ap-gif-preview {
  width: 80px; height: 80px; border-radius: 50%; overflow: hidden;
  border: 2px solid rgba(255,255,255,0.15); position: relative;
  background: rgba(255,255,255,0.05);
}
.ap-gif-preview img { width: 100%; height: 100%; object-fit: cover; display: block; }
.ap-gif-preview--empty { border-style: dashed; }
.ap-gif-remove {
  position: absolute; top: -4px; right: -4px;
  width: 22px; height: 22px; border-radius: 50%;
  background: #EF4444; color: #fff; border: 2px solid #1a1a2e;
  font-size: 11px; cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  line-height: 1; transition: all 0.15s;
}
.ap-gif-remove:hover { background: #dc2626; transform: scale(1.1); }
.ap-gif-upload-btn {
  display: inline-flex; align-items: center; gap: 8px;
  padding: 10px 18px; border-radius: 10px;
  background: rgba(232,106,16,0.12); border: 1.5px solid rgba(232,106,16,0.25);
  color: #E86A10; font-size: 13px; font-weight: 600; cursor: pointer;
  transition: all 0.2s;
}
.ap-gif-upload-btn:hover { background: rgba(232,106,16,0.2); }
</style>
